import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function CategoriesTop({ componentData, getTargetUrl }) {
  if (!componentData) return null;
  return (
    <section className="collection-mobile d-mbl">
      <ul>
        {componentData.data?.map((data, index) => {
          return (
            <li key={index}>
              <Link to={getTargetUrl(data)}>
                <LazyLoadImage
                  alt={""}
                  effect="blur"
                  src={data?.image_src || ""}
                  className="img-fluid mx-auto d-block"
                />
                <h4>{data?.title || ""}</h4>
              </Link>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

export default CategoriesTop;
